import { Component, AfterViewInit, ElementRef, ViewChild, Input } from '@angular/core';
import JsBarcode from 'jsbarcode';

@Component({
  selector: 'app-bar-codes-custom',
  templateUrl: './bar-codes-custom.component.html',
  styleUrls: ['./bar-codes-custom.component.scss']
})
export class BarCodesCustomComponent {

  @Input() barcodeValue!: string; // Recibe el valor del código de barras

  @ViewChild('barcodeCanvas', { static: false }) barcodeCanvas!: ElementRef;

  ngAfterViewInit() {
    if (this.barcodeValue) {
      JsBarcode(this.barcodeCanvas.nativeElement, this.barcodeValue, {
        format: 'CODE128',
        displayValue: true,
        width: 1.5,
        fontSize: 18
      });
    }
  }

}
